import { useEffect } from 'react'
import Label from '../../../ui/Label'
import ClientModalPackage from './ClientModalPackage'
import { setTypeOfAdditionalModal } from '../../../../features/modal/modalSlice'
import { useDispatch, useSelector } from 'react-redux'
import ClientModalActionPanel from './ClientModalActionPanel'
import { clearTypeOfUpdate, clearUpdateClientInfo, selectClientData, selectClientExtraPackage, selectPackageFromApi, selectTypeOfUpdate, setTypeOfUpdate } from '../../../../features/client/clientSlice'
import { showToast } from '../../../../toastify/Toast'
import validateClient from '../../../../hooks/client/validation/validateClient'
import ClientModalAddIconWrap from './ClientModalAddIconWrap'
import ClientModalAllPackageFromApi from './ClientModalAllPackageFromApi'
import { useMutationData } from '../../../../hooks/api/useMutationData'
import useClientAction from '../../../../hooks/actions/useClientAction'

interface ClientModalAllPackagesProps {
    typeOfAction: 'newClient' | 'update'
}

export default function ClientModalAllPackages({ typeOfAction }: ClientModalAllPackagesProps) {

    const dispatch = useDispatch();
    const isUpdate = typeOfAction === 'update'
    const { isLoadingUpdateClientInfo } = useMutationData()
    const typeOfUpdate = useSelector(selectTypeOfUpdate)
    const isUpAddPackage = typeOfUpdate === 'upAddPackage'
    const clientData = useSelector(selectClientData);
    const packageRedux = useSelector(selectClientExtraPackage);
    const allPackageFromApi = useSelector(selectPackageFromApi);
    const { handleUpdateAddPackage } = useClientAction()

    useEffect(() => {
        if (packageRedux?.length > 0) {
            dispatch(setTypeOfUpdate('upAddPackage'))
        } else {
            dispatch(clearTypeOfUpdate())
        }
    }, [packageRedux, dispatch]);

    const handleCancelUpdate = () => {
        dispatch(clearUpdateClientInfo('extraPack'))
        dispatch(clearTypeOfUpdate())
    }

    const handleStartUpdate = () => {}

    const handleShowModalPackage = () => {
        const error = validateClient(clientData)
        if (typeOfAction === 'newClient' && error) {
            showToast(error, "error");
            return;
        }
        dispatch(setTypeOfAdditionalModal('addPackage'))
    }
    
    const hasReduxPackages = packageRedux.length > 0;

    return (
        <div className='space-y-2 pt-2'>
            <Label customCSS={`text-sm font-medium`} label={`${typeOfAction === 'newClient' ? 'Select Additional Package:' : typeOfAction === 'update' ? 'All Packages:' : ''}`} />
                <div className='flex flex-wrap gap-2 pb-2'>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 px-1 w-full">
                        {isUpdate && allPackageFromApi?.map((pkg) => {
                            return (
                                <ClientModalAllPackageFromApi
                                    typeOfAction={typeOfAction}
                                    key={pkg.packageId}
                                    pkg={pkg}
                                />
                            )
                        })}
                        {packageRedux.map((pkg, index) => (
                            <ClientModalPackage
                                key={index}
                                isSaveNewPackages={isUpAddPackage}
                                hasReduxPackages={hasReduxPackages}
                                type={'redux'}
                                typeOfAction={typeOfAction}
                                pkg={pkg}
                            />
                        ))}
                        
                        <ClientModalAddIconWrap
                            onClick={handleShowModalPackage}
                        />
                    </div>
                </div>
                            
            {typeOfAction === 'update' && packageRedux.length !== 0 && (
                <ClientModalActionPanel
                    typeOfAction={typeOfAction}
                    isLoadingUpdateAPI={isLoadingUpdateClientInfo}
                    isUpdateData={packageRedux.length !== 0 ? false : true}
                    handleCancelUpdate={handleCancelUpdate}
                    handleStartUpdate={handleStartUpdate}
                    handleUpdateFinal={handleUpdateAddPackage}
                    labelOne={'Saving...'}
                    labelTwo={'Cancel'}
                    labelThree={'Save package'}
                    labelFour={''}
                    isCustomize={true}
                />
            )}
        </div>
    )
}
